import { render } from "./OperatorSelector.vue?vue&type=template&id=461069c4&scoped=true"
import script from "./OperatorSelector.vue?vue&type=script&lang=ts"
export * from "./OperatorSelector.vue?vue&type=script&lang=ts"

import "./OperatorSelector.vue?vue&type=style&index=0&id=461069c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-461069c4"

export default script